import {PAdbContext} from "../PA.Core/PAdbContext";
import {AuditService} from "../PA.Core/Security/AuditService";
import {FundTypeBO} from "./FundTypeBO";
import {auditFieldFK, AuditUtils, IAuditField} from "../PA.Core/Basic/AuditUtils";
import {AuditLogType} from "../PA.Core/PA.Core.IF.Audit";
import {WB_FundTypeRow} from "../PA.Core/PAdbSchemaRows";
import * as _ from "lodash";

export class FundTypeBOAudit {


    static async FundTypeAuditBO(FundTypeBO: FundTypeBO): Promise<AuditService> {

        const self = FundTypeBO
        const auditService = new AuditService(self.dbContext)
        auditService.setReference("FundType", self.drWB_FundType.cif.WB_FUNDTYPE_ID)

        // @ts-ignore
        self.deleteKeys = self.deleteKeys || {}
        // @ts-ignore
        let deleteKeys: any = self.deleteKeys

        const approvalParams: IAuditField [] = [
            {fieldName: "FUNDTYPE_NAME",              realName: "Name"}, //create
            {fieldName: "FUNDTYPE_ID",                realName: "ID"}, //create
            {fieldName: "RENDER_OPTIONS",  realName: "Render Options"},
            {fieldName: "SOURCE_ID",        realName: "Source"},
            {fieldName: "TREE_PATH",          realName: "Tree Path"},
            {fieldName: "MANUAL_IND",         realName: "Manual"},

        ]

        // Execute Audit Logging
        await AuditUtils.logRecord(auditService, self.WB_FundType, approvalParams, {objectName: 'FundType', deletedKeys: deleteKeys})


        return auditService
    }



}
